import type { FaireProductEntity } from "../../entity_types/product";

export const p_ts7u8ymtzp: FaireProductEntity = {
  token: "p_ts7u8ymtzp",
  type: "product",
  name: "Realistic Butter Stick Squishy Slow Rising Stress Relief Sensory Fidget Toy",
  brandToken: "b_9krr246qu7",
  brandName: "Auraquise",
  imageUrl:
    "https://cdn.faire.com/fastly/894422c1f550b52b4a3ffa3c64d2869989ec6f4d4faf83723f384685e640db95.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e8a43ea2118943b2af7b08020be7717bf0947f5c15f118c9a9256e908b412ecc.jpeg",
    "https://cdn.faire.com/fastly/f732d12f2366fcf4536b9c204c1e1ca5a4a7a357072ab0f02371b6fb7d491157.jpeg",
    "https://cdn.faire.com/fastly/43c8860ef0e08cb6fc52ef9e82f16c448d06985405988d583ea899840d288a18.jpeg",
    "https://cdn.faire.com/fastly/b96e6c7bdd115112ff8a562a6fee4fcc38fffadcf7487ffa258780a95eda3a64.png",
    "https://cdn.faire.com/fastly/3143db68bca911f32802c40dfce5e35e1c2284678dd477ca6f2a81e7176e4edb.jpeg",
    "https://cdn.faire.com/fastly/fafddefff6295a240c3273979b89c14275b74183c72861f8fa5d23af212ed9b9.png",
    "https://cdn.faire.com/fastly/f12d2f8ccee9a1a01617d6dfb7363872b36c3ab86e115751067dff480844091a.jpeg",
    "https://cdn.faire.com/fastly/dd4ea8c0667443c5600b0d168e490eb42784da1e36ffcffe839006eee916fc5d.jpeg",
    "https://cdn.faire.com/fastly/f024dd49ad7e098fdcbca2ac43ec54b4de74c09b0be6f06de0ec94a9b47a217f.jpeg",
    "https://cdn.faire.com/fastly/2dfe0c6a5fbd502572c143d77e9beea2ba5790511bcd13ad055cfd0fcfceb962.jpeg",
    "https://cdn.faire.com/fastly/3f35cc39ddaacf17ff3d53b2438298140ced8a5f17f36e86222da4a78bcb16c9.jpeg",
    "https://cdn.faire.com/fastly/18df601504222f98f675dc410df128983da7a356d03f99e96bf67b39743a8542.jpeg",
    "https://cdn.faire.com/fastly/6b88a786490f282ed887c0e47066d92e1085fb60bca9e3782d546bc2fe66002f.jpeg",
    "https://cdn.faire.com/fastly/ef5a85fc72368bd620b0806e56b21ecbb10466a67e8df4c549b3be508bcba03e.jpeg",
    "https://cdn.faire.com/fastly/e55d196d45eb9bfac91cb75381f9ec7bb33d7ee13f922806c51e617f30a9c933.jpeg",
    "https://cdn.faire.com/fastly/36b3561a22eb1dafcb1758c51da626a5fe725757e1e6d90503ddce542074bcec.jpeg",
    "https://cdn.faire.com/fastly/28625729fe758ed84640c8828087f2ecbdc36859a40078e082a2b8d987513b39.png",
    "https://cdn.faire.com/fastly/ed1db79640d74b5eb9b03d2fb063b67b5d2588e11f3291dad41d146890eec746.jpeg",
    "https://cdn.faire.com/fastly/4bb361241043d6a545af58069d44fde80ef5e70718c1d477c5e66b0c838c2305.jpeg",
    "https://cdn.faire.com/fastly/22757dd1fd2c3beef0663f13ab4f30125bf5af16416d971919680129c304bec6.jpeg",
    "https://cdn.faire.com/fastly/0766ad7685abc419119c40d1d5567664729327c2074d8504ee8ab675d11133ab.jpeg",
    "https://cdn.faire.com/fastly/fed52aa1577fa0f3a386aa3da4b32b4b138ede51932d477d335b5dc76d3d5ce9.jpeg",
    "https://cdn.faire.com/fastly/0c4d1a92da7886850e136af1892d25d7d51d0bc6a90e74e7b43169f27e592429.png",
    "https://cdn.faire.com/fastly/698c4881bc881c17d0566bfef0a77ee93d2561fd5029fdbba4ada6059abf681d.jpeg",
    "https://cdn.faire.com/fastly/6135bf69ec4c8c7912f957afa3bd4906262d295d31bed466d10db703fc652f79.png",
    "https://cdn.faire.com/fastly/ad8265782903e6da32eb4522891da90c87c3113520310b350774068a06119eaf.png",
  ],
  priceDollars: 5.49,
  description:
    "Squeeze away stress with this realistic butter stick squishy. Slow-rising foam design provides satisfying tactile feedback and sensory relief. Perfect for fidgeting, anxiety management, or just having fun. Soft, durable, and endlessly squeezable.",
  tags: [],
  msrpDollars: 10.98,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:27.610Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
